import React from 'react';
import PropTypes from 'prop-types';
import { Manager, Reference, Popper } from 'react-popper';
import classNames from 'classnames';

import i18n, { locales } from '../../i18n';

class LanguageSelector extends React.PureComponent {
    static propTypes = {
        language: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        placement: PropTypes.string
    };

    static defautProps = {
        placement: 'top'
    };

    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.handleToggle = this.handleToggle.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.blur = this.blur.bind(this);
    }

    componentDidUpdate() {
        // simulate blur event to avoid insonsistance browser focus handles
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
        if (this.state.show) {
            document.body.addEventListener('click', this.blur, true);
        } else {
            document.body.removeEventListener('click', this.blur, true);
        }
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.blur, true);
    }

    blur() {
        setTimeout(() => {
            this.setState({ show: false });
        }, 200);
    }

    handleToggle() {
        // add delay on state change to be able to catch click event
        this.setState((state) => ({
            show: !state.show
        }));
    }

    handleClick(e) {
        const locale = e.currentTarget.getAttribute('data-locale');
        this.props.onChange(locale);
        this.setState({ show: false });
    }

    render() {
        const { language } = this.props;
        return (
            <Manager>
                <Reference>
                    {({ ref }) => (
                        <button
                            className="form-control menulist"
                            type="button"
                            ref={ref}
                            onClick={this.handleToggle}
                        >
                            <span>
                                <i className={`flag flag-${language}`}></i> {i18n.t(`common:${language}`)}
                            </span>
                        </button>
                    )}
                </Reference>
                {this.state.show && (
                    <Popper placement={this.props.placement}>
                        {({ ref, style, placement, arrowProps }) => (
                            <div
                                className="menulist-options menulist-languages"
                                ref={ref}
                                style={style}
                                data-placement={placement}
                            >
                                {Object.keys(locales).map((locale) => (
                                    <a
                                        key={locale}
                                        data-locale={locale}
                                        onClick={this.handleClick}
                                        className={classNames({
                                            selected: locale === language
                                        })}
                                    >
                                        <i className={`lang lang-${locale}`}></i>
                                        <span>{i18n.t(`common:${locale}`)}</span>
                                        {locale === language && <i className="icon icon-ok" />}
                                    </a>
                                ))}
                                <div
                                    ref={arrowProps.ref}
                                    style={arrowProps.style}
                                    data-placement={placement}
                                />
                            </div>
                        )}
                    </Popper>
                )}
            </Manager>
        );
    }
}

export default LanguageSelector;
